import { render, staticRenderFns } from "./finalization.vue?vue&type=template&id=cd8ac6b8&scoped=true&"
import script from "./finalization.vue?vue&type=script&lang=js&"
export * from "./finalization.vue?vue&type=script&lang=js&"
import style0 from "./finalization.vue?vue&type=style&index=0&id=cd8ac6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8ac6b8",
  null
  
)

export default component.exports